export const ALLCOUNTRY = 'All Countries';
export const allowRoles: string[] = ['CPak_Affiliate', 'CPak_Contract_Admin', 'CPak_Admin'];
export const ACCOUNT = '/accounts';
export const CATALOG = '/catalog';
export const MAINTENANCE = '/maintenance';
export const CURRENTROUT = 'currentRoute';
export const COUNTRYARRAYLEN = 1;
